<section>

  <form [formGroup]="contactUs.form">
    <div>
      <span id="title">Contact form</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around" fxLayout.xs="column" fxLayoutAlign.xs="space-around">
      <div fxLayout="column" fxFlex="45%" fxLayoutAlign="space-around">

        <mat-form-field>
          <input matInput placeholder="Full Name" required formControlName="name">
          <mat-error align="start" *ngIf="contactUs.form.get('name').hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="Email" type="email" required formControlName="to_email"
                 pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
          <mat-error align="start" *ngIf="contactUs.form.get('to_email').hasError('required')">Required.</mat-error>
          <mat-error align="start" *ngIf="contactUs.form.get('to_email').hasError('pattern')">Invalid Email</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="Subject" required formControlName="msg_subject">
          <mat-error align="start" *ngIf="contactUs.form.get('msg_subject').hasError('required')">Required.</mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxFlex="45%" fxLayoutAlign="space-around">
        <mat-form-field>
          <textarea matInput placeholder="Message" required matTextareaAutosize formControlName="msg_body"></textarea>
          <mat-error align="start" *ngIf="contactUs.form.get('msg_body').hasError('required')">Required.</mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="sendMessage()">
          Send
        </button>
      </div>

    </div>
  </form>
</section>
